import { MakeCall } from './createMakeCall';
import { PayoutMethods } from './types';

/** @swagger /#api-Default-userUserIdPayoutMethodsGet */
export default (makeCall: MakeCall) => () =>
  makeCall<PayoutMethods>('GET', `/api/v2/user/me/payout-methods`);
